module.exports = __webpack_public_path__ + "static/media/profile.aae57c34.jpeg";